var translations = {
	"da-dk": {
	searchPlaceholder: "Søg",
	Products: "Produkter",
	Designs: "Design",
	"Help Center": "Hjælp",
	Inspiration: "Inspiration",
	PersonalizedResults: "Dine design",
	finishEditing: "Afslut redigering",
	reorder: "Genbestil",
	projects: "projekter ({{{ numResults }}})",
	orders: "bestillinger ({{{ numResults }}})",
	seeAll: "Se alle",
	allResultsText: "Se alle resultater",
	clearLabel: "Ryd",
	searchFlyoutLabel: "Der kan være forslag til søgning. Brug pil op og ned til at navigere.",
	outOfStock: "Ikke på lager",
	topSearches: "Mest populære søgninger",
	loading: "Indlæser ...",
	yourRelatedProjects: "Dine relaterede {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Dine relaterede {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Dine relaterede {{{projectsAndCountToken}}} og {{{ordersAndCountToken}}}",
	topResults: "Mest populære resultater",
	category: "Kategori",
	exploreAllResults: "Se alle resultater",
	relatedDesigns: "Relaterede design",
	relatedHelpArticles: "Relaterede hjælpeartikler",
	categories: "Kategorier"
},
	"de-de": {
	searchPlaceholder: "Suchen",
	Products: "Produkte",
	Designs: "Designs",
	"Help Center": "Hilfe",
	Inspiration: "Inspiration",
	PersonalizedResults: "Ihre Designs",
	finishEditing: "Fertig bearbeiten",
	reorder: "Nachbestellen",
	projects: "Projekte ({{{ numResults }}})",
	orders: "Bestellungen ({{{ numResults }}})",
	seeAll: "Alle ansehen",
	allResultsText: "Alle Ergebnisse anzeigen",
	clearLabel: "Entfernen",
	searchFlyoutLabel: "Eventuell sind Suchvorschläge verfügbar. Verwenden Sie die Pfeiltasten zum Navigieren.",
	outOfStock: "Nicht vorrätig",
	topSearches: "Top-Suchen",
	loading: "Wird geladen…",
	yourRelatedProjects: "Ähnliche {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Ähnliche {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Ähnliche {{{projectsAndCountToken}}} und {{{ordersAndCountToken}}}",
	topResults: "Top-Ergebnisse",
	category: "Kategorie",
	exploreAllResults: "Alle Ergebnisse ansehen",
	relatedDesigns: "Ähnliche Designs",
	relatedHelpArticles: "Ähnliche Hilfeartikel",
	categories: "Kategorien"
},
	"en-gb": {
	searchPlaceholder: "Search",
	Products: "Products",
	Designs: "Designs",
	"Help Center": "Help Centre",
	Inspiration: "Inspiration",
	PersonalizedResults: "Your designs",
	finishEditing: "Finish editing",
	reorder: "Reorder",
	projects: "projects ({{{ numResults }}})",
	orders: "orders ({{{ numResults }}})",
	seeAll: "See all",
	allResultsText: "See all results",
	clearLabel: "Clear",
	searchFlyoutLabel: "There may be search suggestions available. Use up and down arrows to navigate.",
	outOfStock: "Out of stock",
	topSearches: "Top Searches",
	loading: "Loading...",
	yourRelatedProjects: "Your related {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Your related {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Your related {{{projectsAndCountToken}}} and {{{ordersAndCountToken}}}",
	topResults: "Top results",
	category: "Category",
	exploreAllResults: "Explore all results",
	relatedDesigns: "Related designs",
	relatedHelpArticles: "Related help articles",
	categories: "Categories"
},
	"en-ie": {
	searchPlaceholder: "Search",
	Products: "Products",
	Designs: "Designs",
	"Help Center": "Help Center",
	Inspiration: "Inspiration",
	PersonalizedResults: "Your designs",
	finishEditing: "Finish editing",
	reorder: "Reorder",
	projects: "projects ({{{ numResults }}})",
	orders: "orders ({{{ numResults }}})",
	seeAll: "See all",
	allResultsText: "See all results",
	clearLabel: "Clear",
	searchFlyoutLabel: "There may be search suggestions available. Use up and down arrows to navigate.",
	outOfStock: "Out of stock",
	topSearches: "Top Searches",
	loading: "Loading...",
	yourRelatedProjects: "Your related {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Your related {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Your related {{{projectsAndCountToken}}} and {{{ordersAndCountToken}}}",
	topResults: "Top results",
	category: "Category",
	exploreAllResults: "Explore all results",
	relatedDesigns: "Related designs",
	relatedHelpArticles: "Related help articles",
	categories: "Categories"
},
	"en-in": {
	searchPlaceholder: "Search",
	Products: "Products",
	Designs: "Designs",
	"Help Center": "Help Center",
	Inspiration: "Inspiration",
	PersonalizedResults: "Your designs",
	finishEditing: "Finish editing",
	reorder: "Reorder",
	projects: "projects ({{{ numResults }}})",
	orders: "orders ({{{ numResults }}})",
	seeAll: "See all",
	allResultsText: "See all results",
	clearLabel: "Clear",
	searchFlyoutLabel: "There may be search suggestions available. Use up and down arrows to navigate.",
	outOfStock: "Out of stock",
	topSearches: "Top Searches",
	loading: "Loading...",
	yourRelatedProjects: "Your related {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Your related {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Your related {{{projectsAndCountToken}}} and {{{ordersAndCountToken}}}",
	topResults: "Top results",
	category: "Category",
	exploreAllResults: "Explore all results",
	relatedDesigns: "Related designs",
	relatedHelpArticles: "Related help articles",
	categories: "Categories"
},
	"es-es": {
	searchPlaceholder: "Buscar",
	Products: "Productos",
	Designs: "Diseños",
	"Help Center": "Centro de ayuda",
	Inspiration: "Inspiración",
	PersonalizedResults: "Tus diseños",
	finishEditing: "Terminar de editar",
	reorder: "Volver a pedir",
	projects: "proyectos ({{{ numResults }}})",
	orders: "pedidos ({{{ numResults }}})",
	seeAll: "Ver todo",
	allResultsText: "Ver todos los resultados",
	clearLabel: "Borrar",
	searchFlyoutLabel: "Puede haber sugerencias de búsqueda disponibles. Usa las flechas hacia arriba y abajo para navegar.",
	outOfStock: "Agotado",
	topSearches: "Búsquedas más frecuentes",
	loading: "Cargando...",
	yourRelatedProjects: "Tus {{{projectsAndCountToken}}} relacionados",
	yourRelatedOrders: "Tus {{{ordersAndCountToken}}} relacionados",
	yourRelatedProjectsAndOrders: "Tus {{{projectsAndCountToken}}} y {{{ordersAndCountToken}}} relacionados",
	topResults: "Resultados destacados",
	category: "Categoría",
	exploreAllResults: "Explorar todos los resultados",
	relatedDesigns: "Diseños relacionados",
	relatedHelpArticles: "Artículos de ayuda relacionados",
	categories: "Categorías"
},
	"es-us": {
	searchPlaceholder: "Buscar",
	Products: "Productos",
	Designs: "Diseños",
	"Help Center": "Centro de ayuda",
	Inspiration: "Inspiración",
	PersonalizedResults: "Sus diseños",
	finishEditing: "Terminar de editar",
	reorder: "Volver a pedir",
	projects: "proyectos ({{{ numResults }}})",
	orders: "pedidos ({{{ numResults }}})",
	seeAll: "Ver todo",
	allResultsText: "Ver todos los resultados",
	clearLabel: "Transparente",
	searchFlyoutLabel: "Podrían haber sugerencias disponibles. Usar las flechas hacia arriba y abajo para navegar.",
	outOfStock: "Agotado",
	topSearches: "Búsquedas más frecuentes",
	loading: "Cargando...",
	yourRelatedProjects: "Tus {{{projectsAndCountToken}}} relacionados",
	yourRelatedOrders: "Tus {{{ordersAndCountToken}}} relacionados",
	yourRelatedProjectsAndOrders: "Tus {{{projectsAndCountToken}}} y {{{ordersAndCountToken}}} relacionados",
	topResults: "Resultados destacados",
	category: "Categoría",
	exploreAllResults: "Explorar todos los resultados",
	relatedDesigns: "Diseños relacionados",
	relatedHelpArticles: "Artículos de ayuda relacionados",
	categories: "Categorías"
},
	"fi-fi": {
	searchPlaceholder: "Hae",
	Products: "Tuotteet",
	Designs: "Mallit",
	"Help Center": "Ohjekeskus",
	Inspiration: "Inspiraatiota",
	PersonalizedResults: "Omat mallisi",
	finishEditing: "Lopeta muokkaus",
	reorder: "Tilaa uudelleen",
	projects: "projektit ({{{ numResults }}})",
	orders: "tilaukset ({{{ numResults }}})",
	seeAll: "Näytä kaikki",
	allResultsText: "Näytä kaikki tulokset",
	clearLabel: "Läpinäkyvä",
	searchFlyoutLabel: "Hakuehdotuksia saattaa olla saatavilla. Liiku ylös- ja alaspäin osoittavilla nuolilla.",
	outOfStock: "Tilapäisesti lopussa",
	topSearches: "Suosituimmat haut",
	loading: "Ladataan...",
	yourRelatedProjects: "Tähän liittyvät {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Tähän liittyvät {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Tähän liittyvät {{{projectsAndCountToken}}} ja {{{ordersAndCountToken}}}",
	topResults: "Tärkeimmät tulokset",
	category: "Luokka",
	exploreAllResults: "Näytä kaikki tulokset",
	relatedDesigns: "Tähän liittyvät mallit",
	relatedHelpArticles: "Tähän liittyvät ohjeartikkelit",
	categories: "Kategoriat"
},
	"fr-ca": {
	searchPlaceholder: "Rechercher",
	Products: "Produits",
	Designs: "Graphismes",
	"Help Center": "Centre d’assistance",
	Inspiration: "Idées",
	PersonalizedResults: "Vos graphismes",
	finishEditing: "Terminer les modifications",
	reorder: "Renouveler la commande",
	projects: "créations ({{{ numResults }}})",
	orders: "commandes ({{{ numResults }}})",
	seeAll: "Tout afficher",
	allResultsText: "Voir tous les résultats",
	clearLabel: "Effacer",
	searchFlyoutLabel: "Des suggestions de recherche sont peut-être disponibles. Utilisez les flèches verticales ascendante et descendante pour naviguer.",
	outOfStock: "En rupture de stock",
	topSearches: "Recherches les plus fréquentes",
	loading: "Chargement en cours...",
	yourRelatedProjects: "Vos {{{projectsAndCountToken}}} connexes",
	yourRelatedOrders: "Vos {{{ordersAndCountToken}}} connexes",
	yourRelatedProjectsAndOrders: "Vos {{{projectsAndCountToken}}} et {{{ordersAndCountToken}}} connexes",
	topResults: "Meilleurs résultats",
	category: "Catégorie",
	exploreAllResults: "Explorer tous les résultats",
	relatedDesigns: "Graphismes connexes",
	relatedHelpArticles: "Articles d’aide connexes",
	categories: "Catégories"
},
	"fr-fr": {
	searchPlaceholder: "Rechercher",
	Products: "Produits",
	Designs: "Graphismes",
	"Help Center": "Centre d’assistance",
	Inspiration: "Inspiration",
	PersonalizedResults: "Vos graphismes",
	finishEditing: "Terminer la modification",
	reorder: "Commander à nouveau",
	projects: "projets ({{{ numResults }}})",
	orders: "commandes ({{{ numResults }}})",
	seeAll: "Voir tout",
	allResultsText: "Voir tous les résultats",
	clearLabel: "Effacer",
	searchFlyoutLabel: "Il se peut que des suggestions de recherche soient disponibles. Utilisez les flèches haut et bas pour naviguer.",
	outOfStock: "En rupture de stock",
	topSearches: "Recherches populaires",
	loading: "En cours de chargement...",
	yourRelatedProjects: "Vos {{{projectsAndCountToken}}} associés",
	yourRelatedOrders: "Vos {{{ordersAndCountToken}}} associées",
	yourRelatedProjectsAndOrders: "Vos {{{projectsAndCountToken}}} et {{{ordersAndCountToken}}} associés",
	topResults: "Meilleurs résultats",
	category: "Catégorie",
	exploreAllResults: "Parcourir tous les résultats",
	relatedDesigns: "Graphismes associés",
	relatedHelpArticles: "Articles d’aide associés",
	categories: "Catégories"
},
	"it-it": {
	searchPlaceholder: "Cerca",
	Products: "Prodotti",
	Designs: "Design",
	"Help Center": "Centro assistenza",
	Inspiration: "Ispirazione",
	PersonalizedResults: "I tuoi design",
	finishEditing: "Completa le modifiche",
	reorder: "Ripeti ordine",
	projects: "progetti ({{{ numResults }}})",
	orders: "ordini ({{{ numResults }}})",
	seeAll: "Vedi tutti",
	allResultsText: "Vedi tutti i risultati",
	clearLabel: "Cancella",
	searchFlyoutLabel: "Potrebbero essere disponibili alcuni suggerimenti di ricerca. Usa le frecce per muoverti in alto o in basso.",
	outOfStock: "Non disponibile",
	topSearches: "Ricerche più popolari",
	loading: "Caricamento in corso...",
	yourRelatedProjects: "{{{projectsAndCountToken}}} correlato",
	yourRelatedOrders: "{{{ordersAndCountToken}}} correlato",
	yourRelatedProjectsAndOrders: "{{{projectsAndCountToken}}} e {{{ordersAndCountToken}}} correlati",
	topResults: "I migliori risultati",
	category: "Categoria",
	exploreAllResults: "Esplora tutti i risultati",
	relatedDesigns: "Design correlati",
	relatedHelpArticles: "Articoli di assistenza correlati",
	categories: "Categorie"
},
	"nb-no": {
	searchPlaceholder: "Søk",
	Products: "Produkter",
	Designs: "Design",
	"Help Center": "Kundeservice",
	Inspiration: "Inspirasjon",
	PersonalizedResults: "Dine design",
	finishEditing: "Avslutte redigering",
	reorder: "Bestill på nytt",
	projects: "prosjekter ({{{ numResults }}})",
	orders: "bestillinger ({{{ numResults }}})",
	seeAll: "Vis alle",
	allResultsText: "Vis alle resultater",
	clearLabel: "Fjern",
	searchFlyoutLabel: "Det kan finnes søkeforslag tilgjengelig. Bruk pilene opp og ned for å navigere.",
	outOfStock: "Utsolgt",
	topSearches: "Toppsøk",
	loading: "Laster ...",
	yourRelatedProjects: "Dine relaterte {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Dine relaterte {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Dine relaterte {{{projectsAndCountToken}}} og {{{ordersAndCountToken}}}",
	topResults: "Toppresultater",
	category: "Kategori",
	exploreAllResults: "Vis alle resultater",
	relatedDesigns: "Relaterte design",
	relatedHelpArticles: "Relaterte hjelpeartikler",
	categories: "Kategorier"
},
	"nl-nl": {
	searchPlaceholder: "Zoeken",
	Products: "Producten",
	Designs: "Ontwerpen",
	"Help Center": "Help",
	Inspiration: "Inspiratie",
	PersonalizedResults: "Jouw ontwerpen",
	finishEditing: "Bewerken voltooien",
	reorder: "Nabestellen",
	projects: "projecten ({{{ numResults }}})",
	orders: "bestellingen ({{{ numResults }}})",
	seeAll: "Alles bekijken",
	allResultsText: "Alle resultaten bekijken",
	clearLabel: "Transparant",
	searchFlyoutLabel: "Er kunnen zoeksuggesties beschikbaar zijn. Gebruik de pijltjestoetsen naar boven en beneden om te navigeren.",
	outOfStock: "Niet op voorraad",
	topSearches: "Meest gezocht",
	loading: "Bezig met laden...",
	yourRelatedProjects: "Jouw gerelateerde {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Jouw gerelateerde {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Jouw gerelateerde {{{projectsAndCountToken}}} en {{{ordersAndCountToken}}}",
	topResults: "Beste resultaten",
	category: "Categorie",
	exploreAllResults: "Bekijk alle resultaten",
	relatedDesigns: "Gerelateerde ontwerpen",
	relatedHelpArticles: "Gerelateerde helpartikelen",
	categories: "Categorieën"
},
	"pt-pt": {
	searchPlaceholder: "Procurar",
	Products: "Produtos",
	Designs: "Designs",
	"Help Center": "Centro de Ajuda",
	Inspiration: "Inspiração",
	PersonalizedResults: "Os seus designs",
	finishEditing: "Concluir a edição",
	reorder: "Voltar a encomendar",
	projects: "projetos ({{{ numResults }}})",
	orders: "encomendas ({{{ numResults }}})",
	seeAll: "Ver tudo",
	allResultsText: "Ver todos os resultados",
	clearLabel: "Limpar",
	searchFlyoutLabel: "Poderão estar disponíveis sugestões de pesquisa. Utilize as setas para cima e para baixo para navegar.",
	outOfStock: "Esgotado",
	topSearches: "Principais pesquisas",
	loading: "A carregar...",
	yourRelatedProjects: "Os seus {{{projectsAndCountToken}}} relacionados",
	yourRelatedOrders: "Os seus {{{ordersAndCountToken}}} relacionados",
	yourRelatedProjectsAndOrders: "Os seus {{{projectsAndCountToken}}} e as suas {{{ordersAndCountToken}}} relacionados",
	topResults: "Principais resultados",
	category: "Categoria",
	exploreAllResults: "Explorar todos os resultados",
	relatedDesigns: "Designs relacionados",
	relatedHelpArticles: "Artigos de ajuda relacionados",
	categories: "Categorias"
},
	"sv-se": {
	searchPlaceholder: "Sök",
	Products: "Produkter",
	Designs: "Designer",
	"Help Center": "Hjälpcenter",
	Inspiration: "Inspiration",
	PersonalizedResults: "Dina designer",
	finishEditing: "Slutför redigering",
	reorder: "Efterbeställ",
	projects: "projekt ({{{ numResults }}})",
	orders: "beställningar ({{{ numResults }}})",
	seeAll: "Visa alla",
	allResultsText: "Visa alla resultat",
	clearLabel: "Rensa",
	searchFlyoutLabel: "Det kan finnas sökförslag. Använd uppåt- och nedåtpilarna för att navigera.",
	outOfStock: "Ej i lager",
	topSearches: "Vanligaste sökningarna",
	loading: "Läser in ...",
	yourRelatedProjects: "Relaterade {{{projectsAndCountToken}}}",
	yourRelatedOrders: "Relaterade {{{ordersAndCountToken}}}",
	yourRelatedProjectsAndOrders: "Relaterade {{{projectsAndCountToken}}} och {{{ordersAndCountToken}}}",
	topResults: "Toppresultat",
	category: "Kategori",
	exploreAllResults: "Utforska alla resultat",
	relatedDesigns: "Liknande designer",
	relatedHelpArticles: "Liknande hjälpartiklar",
	categories: "Kategorier"
}
};

export { translations as default };
//# sourceMappingURL=translations.json.js.map
